/* eslint-env browser */
'use strict'
module.exports = fetch
